export const SEGMENT = 'customer_segment';
export const BROADCAST = 'broadcast';
export const DIY = 'diy';
export const ORDER = 'order';
export const REQUEST = 'request';
export const ROUTE = 'route';
